import { render, staticRenderFns } from "./CabinetPowerWizard.vue?vue&type=template&id=00bff542&"
import script from "./CabinetPowerWizard.vue?vue&type=script&lang=js&"
export * from "./CabinetPowerWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports